module.exports = __webpack_public_path__ + "img/Ingenierito transformer volteado 1.af538853.png";